import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiAccessoriL1SectionWrapper,
  InspectionInfoScheda20Form,
} from 'components';
import {
  schemaPonteCommonOptions,
  tipologiaParapettoOptions,
} from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import ParapettiForm from './ParapettiForm';
const ParapettiSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();

  const sovrastrutturaImpalcatoTableParapettiTableWatch = watch(
    `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable`
  );

  const sovrastrutturaImpalcatoTable = watch(`sovrastrutturaImpalcatoTable`);
  //console.log(sovrastrutturaImpalcatoTable, 'sovrastrutturaImpalcatoTable');

  const mensoleTamponiCampateToCopy = sovrastrutturaImpalcatoTable?.map(
    el => el.parapettiTable
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsParapetti = item => {
    setValue('parapettiTableValue', [item]);
    setValue('tipologiaParapettoTableValue', item.tipologiaParapetto);
  };

  const handleSelectAllClickParapetti = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable`
      );
      setSelected(selectedValue);
      setValue('parapettiTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('parapettiTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t3a2_tecnicoRilevatoreParapetti',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t3a2_dataIspezioneParapetti',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t3a2_noteGeneraliParapetti',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues('l1t3a2_tecnicoRilevatoreParapetti');
    const dataIspezione = getValues('l1t3a2_dataIspezioneParapetti');

    const noteGenerali = getValues('l1t3a2_noteGeneraliParapetti');
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
  };

  const handleResetInspection = () => {
    setValue(`l1t3a2_tecnicoRilevatoreParapetti`, '');
    setValue(`l1t3a2_dataIspezioneParapetti`, null);
    setValue(`l1t3a2_noteGeneraliParapetti`, '');
  };

  const dataParapettiConfig = {
    columns: {
      codice: { label: 'Cod.' },
      presenza: { label: 'Parapetto', format: schemaPonteCommonOptions },
      tipologiaParapetto: {
        label: 'Tipologia',
        format: tipologiaParapettoOptions,
      },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      nrtotali: { label: 'NR' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaParapetto: {
        label: 'Tipologia',
        format: tipologiaParapettoOptions,
      },
    },
  };

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiAccessoriL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'parapetti'}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoParapetti.drawerTitle}
        drawerText={INFO.impalcatoParapetti.drawerText}
        singleElementTitle={'parapetto'}
        tableWatch={sovrastrutturaImpalcatoTableParapettiTableWatch}
        tableWatchName={`sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable`}
        elementForm={
          <ParapettiForm
            parapettiFields={
              sovrastrutturaImpalcatoTableParapettiTableWatch || []
            }
            selected={selected}
            setSelected={setSelected}
            parapettiTable={`sovrastrutturaImpalcatoTable[${selectedIdx}].parapettiTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoScheda20Form
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t3a2_tecnicoRilevatoreParapetti'}
            dateName={'l1t3a2_dataIspezioneParapetti'}
            noteGeneraliName={'l1t3a2_noteGeneraliParapetti'}
          />
        }
        tableConfig={dataParapettiConfig}
        editRows={editRowsParapetti}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickParapetti}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={'tipologiaParapetto'}
        tableForCopy={mensoleTamponiCampateToCopy}
      />
    </>
  );
};
ParapettiSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default ParapettiSection;
